// sportAdapters/index.js
import mlbAdapter from './mlbAdapter';
import nflAdapter from './nflAdapter';
import nbaAdapter from './nbaAdapter';

export const getSportAdapter = (sport) => {
    if(!sport) return null;
    
    switch (sport.toLowerCase()) {
        case 'mlb':
            return mlbAdapter;
        case 'nfl':
            return nflAdapter;
        case 'nba':
            return nbaAdapter;
        default:
            return null;
    }
};